import * as React from 'react';

import {getSingularEntityType} from 'nutshell-core/utils/get-singular-entity-type';

import {EmailNoAddressesModal} from '../../email/email-no-addresses-modal';
import {useGetEntityEmailAddresses} from '../../email/use-get-entity-email-addresses';

import {BulkPersonalEmailModal} from './bulk-email/bulk-email-modals/bulk-personal-email-modal';
import type {Props as BulkPersonalEmailProps} from './bulk-email/bulk-email-modals/bulk-personal-email-modal';
import {SendMarketingOutreachModal} from './marketing-outreach/send-marketing-outreach-modal';
import type {Props as BulkMarketingOutreachProps} from './marketing-outreach/send-marketing-outreach-modal';
import {SendFromListSelectionModal} from './send-from-list-selection-modal';
import type {Props as BulkEmailSelectionProps} from './send-from-list-selection-modal';

export type SendFromListOption = 'personal' | 'marketing';

type Props = // For selection modal
    BulkEmailSelectionProps & {
        // For opening individual personal email composer
        handleOpenPersonalEmailComposer: () => void;
    } & BulkPersonalEmailProps & // For bulk personal email modal // For marketing email modal
        BulkMarketingOutreachProps;

// Send email from list modal controller
export function SendFromListModal(props: Props) {
    const [selectedModal, setSelectedModal] = React.useState<
        SendFromListOption | null | undefined
    >();

    const {entity, isLoadingRelatedEmails} = useGetEntityEmailAddresses(
        props.selectedItems[0],
        props.selectedCount !== 1
    );

    let modalToShow;

    if (selectedModal === 'marketing') {
        modalToShow = (
            <SendMarketingOutreachModal
                onClose={props.onClose}
                numRecipients={props.numRecipients}
                entityType={props.entityType}
                query={props.query}
                massSelect={props.massSelect}
                selectedItems={props.selectedItems}
                omittedItems={props.omittedItems}
                canAccessFullCampaigns={props.canAccessFullCampaigns}
            />
        );
    }

    if (selectedModal === 'personal') {
        modalToShow = (
            <BulkPersonalEmailModal
                onClose={props.onClose}
                userId={props.userId}
                entityType={props.entityType}
                query={props.query}
                massSelect={props.massSelect}
                selectedItems={props.selectedItems}
                omittedItems={props.omittedItems}
                onEmailSend={props.onEmailSend}
            />
        );
    }

    if (!selectedModal) {
        modalToShow = (
            <SendFromListSelectionModal
                onClose={props.onClose}
                userEmail={props.userEmail}
                selectedCount={props.selectedCount}
                canAccessMarketing={props.canAccessMarketing}
                onSelectOption={(selection: SendFromListOption) => {
                    if (selection === 'personal' && props.selectedCount === 1) {
                        // If not bulk sending, we'll open the email composer and close this modal out
                        props.handleOpenPersonalEmailComposer();
                        props.onClose();
                    } else {
                        setSelectedModal(selection);
                    }
                }}
                // Will show loading state if querying for entity related emails
                isLoadingRelatedEmails={isLoadingRelatedEmails}
            />
        );
    }

    return (
        <>
            {entity && entity.relatedEmailAddresses.all.length < 1 ? (
                <EmailNoAddressesModal
                    isOpen={true}
                    onClose={props.onClose}
                    entityType={getSingularEntityType(entity.type)}
                    entityUrl={entity.htmlUrl}
                />
            ) : (
                modalToShow
            )}
        </>
    );
}
